import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import ProductListActions from "@insite/content-library/Widgets/ProductList/ProductListActions";
import ProductListProductImage from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import ProductListProductInformation from "@insite/content-library/Widgets/ProductList/ProductListProductInformation";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { ProductCardSelections } from "@MasterBluePrint/Overrides/Widgets/ProductList/ProductCardSelections";
import ProductListHazmatIcon from "@MasterBluePrint/Overrides/Widgets/ProductList/ProductListHazmatIcon";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = ProductCardSelections & HasProduct;

export interface ProductListProductGridCardStyles {
    wrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    sponsoredText?: TypographyPresentationProps;
}

export const productGridCardStyles: ProductListProductGridCardStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            overflow: hidden;
            padding-bottom: .625rem;
        `,
    },
    imageWrapper: {
        css: css`
            margin: auto;
            padding: .625rem 3.125rem;
        `,
    },
    sponsoredText: {
        css: css`
            font-size: .9em;
            opacity: .5;
            position: absolute;
            top: .75rem;
        `,
    },
};

const styles = productGridCardStyles;

const ProductListProductGridCard: FC<Props> = ({
    product,
    showImage,
    showCompare,
    showAttributes,
    showAvailability,
    showBrand,
    showPartNumbers,
    showTitle,
    showAddToList,
    showPrice,
    showShippingRestrictionIcon,
    showHazardousGoodIcon,
    showImageBadges,
    maximumNumberOfImageBadges,
    showTextBadges,
    maximumNumberOfTextBadges,
}) => {
    return (
        <StyledWrapper {...styles.wrapper} data-test-selector={`productListProductCard${product.id}`}>
            <StyledWrapper {...styles.imageWrapper}>
                {product.isSponsored && <Typography {...styles.sponsoredText}>{translate("Sponsored")}</Typography>}
                <ProductListProductImage
                    showImage={showImage}
                    showCompare={showCompare}
                    showImageBadge={showImageBadges}
                    showTextBadge={showTextBadges}
                />
            </StyledWrapper>
            <ProductListProductInformation
                showAttributes={showAttributes}
                showAvailability={showAvailability}
                showBrand={showBrand}
                showPartNumbers={showPartNumbers}
                showTitle={showTitle}
                showImageBadges={showImageBadges}
                maxImageBadges={maximumNumberOfImageBadges}
                showTextBadges={showTextBadges}
                maxTextBadges={maximumNumberOfTextBadges}
            />
            <ProductListHazmatIcon
                showShippingRestrictionIcon={showShippingRestrictionIcon}
                showHazardousGoodIcon={showHazardousGoodIcon}
            />
            <ProductListActions 
                showAddToList={showAddToList} 
                showPrice={showPrice}
            />

        </StyledWrapper>
    );
};

export default withProduct(ProductListProductGridCard);
